<ng-container *ngIf="showAsCard">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <h3 *ngIf="showTitle" class="text-center">Questionario RIATLAS HEALTHCARE usability (SUS)
                            </h3>
                        </div>
                        <div class="col-12">
                            <ng-container *ngTemplateOutlet="contenuto"></ng-container>
                        </div>
                        <div class="col-12 mt-5">
                            <div class="float-right" style="margin-right: 15px; margin-bottom: 15px;">
                                <button *ngIf="checkPermessoModifica()" pButton label="Salva" icon="fa fa-save"
                                    iconPos="left" class="p-button-success" type="button" (click)="salva()"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!showAsCard && !showFullPage">
    <ng-container *ngTemplateOutlet="contenuto"></ng-container>
</ng-container>

<ng-container *ngIf="showFullPage">
    <div class="row">
        <div class="col-12">
            <h3 *ngIf="showTitle" class="text-center">Questionario RIATLAS HEALTHCARE usability (SUS)
            </h3>
        </div>
        <div class="col-12">
            <ng-container *ngTemplateOutlet="contenuto"></ng-container>
        </div>
        <div class="col-12">
            <div class="col-12 mt-5">
                <div class="float-right" style="margin-right: 15px; margin-bottom: 15px;">
                    <button *ngIf="checkPermessoModifica()" pButton label="Salva" icon="fa fa-save" iconPos="left"
                        class="p-button-success" type="button" (click)="salva()"></button>
                </div>
            </div>
        </div>

    </div>
</ng-container>



<ng-template #contenuto>
    <ng-container *ngFor="let domanda of domande;let indexOfelement=index;">
        <div class="row mt-5">
            <div class="col-5 pt-3">
                <h5>{{domanda.testo}}{{domanda.tipo == 'integer' ? "*" : ""}}</h5>
            </div>
            <div class="offset-1 col-5 custom-slider" *ngIf="domanda.tipo == 'integer'">
                <ng5-slider style="white-space: nowrap;" [options]="domanda.options" [(ngModel)]="domanda.risposta"
                    (mouseup)="onSliderMouseup(domanda)" (click)="onSliderMouseup(domanda)">
                </ng5-slider>
            </div>
            <div class="offset-1 col-5" *ngIf="domanda.tipo == 'string'">
                <textarea [rows]="3" [cols]="100" pInputTextarea autoResize="autoResize" [(ngModel)]="domanda.risposta"
                    class="form-control" (ngModelChange)="OnChange()"></textarea>
            </div>
        </div>
    </ng-container>
</ng-template>